<!-- <mat-card-header class="titreFrm">
    <mat-card-title>Suppression !</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div style="padding: 10px 10px 0 10px; ">
      <h4>{{message}}</h4>

      
    </div>

  </mat-card-content>
  <div align="end">
    <button style="margin-right: 10px;" (click)="close('annuler')" mat-raised-button [ngClass]="btnAnnuler.class"><mat-icon>{{btnAnnuler.icon}}</mat-icon>{{btnAnnuler.text}}</button>
    <button (click)="close('supprimer')" mat-raised-button [ngClass]="btnOk.class"><mat-icon>{{btnOk.icon}}</mat-icon>{{btnOk.text}}</button>
  </div> -->

<div
  class="min-w-screen h-screen fixed flex justify-center items-center inset-0 z-50 transition"
>
  <div class="absolute bg-black opacity-80 inset-0 z-0"></div>
  <div
    class="w-full max-w-lg p-5 relative mx-auto my-auto rounded-xl shadow-lg bg-white"
  >
    <!--content-->
    <div class="">
      <!--body-->
      <div class="text-center p-5 flex-auto justify-center">
        <svg
          class="w-25 h-25 -m-1 flex items-center text-red-500 mx-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <svg
          class="w-50 h-50 flex items-center text-red-500 mx-auto"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
        <h2 class="text-xl font-bold py-4">Es-tu sûr?</h2>
        <p class="text-lg text-gray-500 px-8">
          {{ message }}
        </p>
      </div>
      <!--footer-->
      <div
        class="p-3 mt-2 text-center space-x-4 md:block"
        *ngIf="!router.url.startsWith('/avt/grh/tarif/reservation')"
      >
        <button
          (click)="close('annuler')"
          class="mb-2 md:mb-0 bg-white px-5 py-8 text-xl shadow-sm font-medium tracking-wider border text-gray-600 rounded-lg hover:shadow-lg hover:bg-gray-100"
        >
          Annuler
        </button>
        <button
          (click)="close('supprimer')"
          class="mb-2 md:mb-0 bg-red-500 border border-red-500 px-5 py-8 text-xl shadow-sm font-medium tracking-wider text-white rounded-lg hover:shadow-lg hover:bg-red-600"
        >
          Supprimer
        </button>
      </div>
      <div
        class="p-3 mt-2 text-center space-x-4 md:block"
        *ngIf="router.url.startsWith('/avt/grh/tarif/reservation')"
      >
        <button
          (click)="close('annuler')"
          class="mb-2 md:mb-0 bg-white px-3 py-8 text-xl shadow-sm font-medium tracking-wider border text-gray-600 rounded-lg hover:shadow-lg hover:bg-gray-100"
        >
          Annuler
        </button>
        <button
          (click)="close('supprimer')"
          class="mb-2 md:mb-0 bg-red-500 border border-red-500 px-3 py-8 text-xl shadow-sm font-medium tracking-wider text-white rounded-lg hover:shadow-lg hover:bg-red-600"
        >
          Supprimer
        </button>
        <button
          (click)="close('deactivate')"
          class="mb-2 md:mb-0 bg-indigo-600 border border-indbg-indigo-600 px-3 py-8 text-xl shadow-sm font-medium tracking-wider text-white rounded-lg hover:shadow-lg hover:bg-red-600"
        >
          Désactiver Tarif
        </button>
      </div>
    </div>
  </div>
</div>
